(function ($, window, document) {
  let howToApplySlide = 0,
    historyDetailSlider = 0;

  function addZeroToInitial(num) {
    return num.length > 1 ? num : "0" + num;
  }

  function fadeInSliderDescription(speed, contentClassName, previousSlideImage, activeSlideImage) {
    // Fade out the previous slide's image to opacity 0.2
    const previousContent = $(previousSlideImage).find(contentClassName);
    gsap.to(previousContent, {
      opacity: 0,
      duration: (speed / 1000) * 0.5, // Fade out duration proportional to speed
      delay: 0.5, // Synchronize with the completion of the text animation
      ease: "power2.out", // Use smoother easing
    });

    // Fade in the current slide's image synchronously with the text animation
    const activeImage = $(activeSlideImage).find(contentClassName);
    gsap.fromTo(
      activeImage,
      { opacity: 0.01 }, // Start with low opacity
      {
        opacity: 1, // Fade in to full opacity
        duration: speed / 1000 + 0.5, // Fade in duration proportional to speed
        delay: (speed / 1000) * 1.1, // Synchronize with the completion of the text animation
        ease: "power2.out", // Use smoother easing
      }
    );
  }

  $(window).on("load", function () {
    if ($(".banner-swiper").length > 0) {
      $(".banner-swiper .swiper-slide").removeClass("invisible");
    
      // Initialize the thumbnail Swiper
      const swiperBannerTabs = new Swiper(".banner-image-thumb-container", {
        spaceBetween: 30,
        slidesPerView: 1,
        effect: "fade",
        speed: 1000,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            allowTouchMove: false,
          },
          995: {
            allowTouchMove: false,
          },
        },
      });
    
      // Initialize the main Swiper
      const swiper = new Swiper(".banner-swiper", {
        slidesPerView: 1,
        effect: "fade",
        speed: 1000,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            allowTouchMove: true,
          },
          995: {
            allowTouchMove: false,
          },
        },
        pagination: {
          el: ".banner-swiper .swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        thumbs: {
          swiper: swiperBannerTabs, // Connect the thumbnail Swiper
        },
        on: {
          slideChange: function () {
            // Get the speed of the swiper
            const speed = this.params.speed || 1000; // Default to 1000ms if speed is not defined
    
            // Get the previous slide
            const previousSlide = this.slides[this.previousIndex];
    
            // Find the heading elements inside the previous slide
            const previousHeadings = $(previousSlide).find(".text-up-stagger-animate");
    
            // Calculate total animation duration for the previous slide's lines
            let totalDuration = 0;
            previousHeadings.each(function (index, element) {
              const lines = new SplitType(element, {
                types: "lines",
                lineClass: "line",
              }).lines;
              totalDuration += lines.length * (speed / 1000) * 0.5; // Assuming each line takes 0.5 times the speed
            });
    
            // Get the current slide
            const activeSlide = this.slides[this.activeIndex];
    
            // Find the heading elements inside the current slide
            const headings = $(activeSlide).find(".text-up-stagger-animate");
    
            // Slide down animation for the text of the previous slide
            previousHeadings.each(function (index, element) {
              const lines = new SplitType(element, {
                types: "lines",
                lineClass: "line",
              }).lines;
    
              lines.forEach(function (line, lineIndex) {
                const words = new SplitType(line, {
                  types: "lines",
                  lineClass: "line",
                }).lines;
    
                words.forEach(function (word, wordIndex) {
                  gsap.to(word, {
                    y: "100%", // Slide down to hide inside the parent div
                    duration: (speed / 1000) * 0.5, // Duration proportional to speed
                    ease: "power2.out", // Use smoother easing
                  });
                });
              });
            });
    
            // Slide up animation for the text of the current slide
            headings.each(function (index, element) {
              const lines = new SplitType(element, {
                types: "lines",
                lineClass: "line",
              }).lines;
    
              lines.forEach(function (line, lineIndex) {
                const words = new SplitType(line, {
                  types: "lines",
                  lineClass: "line",
                }).lines;
    
                words.forEach(function (word, wordIndex) {
                  const delay =
                    totalDuration + lineIndex * (speed / 1000) * 0.1; // Delay each line animation
                  gsap.fromTo(
                    word,
                    { y: "100%" }, // Start from the bottom
                    {
                      y: 0, // Slide up to its original position
                      duration: (speed / 1000) * 0.5, // Duration proportional to speed
                      delay: delay,
                      ease: "power2.out", // Use smoother easing
                    }
                  );
                });
              });
            });
    
            const previousSlideIndex = this.slides[this.previousIndex],
              activeSlideIndex = this.slides[this.activeIndex];
            fadeInSliderDescription(speed + 200, ".description", previousSlideIndex, activeSlideIndex); //animate description
            fadeInSliderDescription(speed + 200, ".btn-container", previousSlideIndex, activeSlideIndex); //animate btn
          },
        },
      });

      // Disable autoplay initially
      swiper.autoplay.stop();
      swiperBannerTabs.autoplay.stop();
      let userInteracted = false;

      // Add event listener to start autoplay on user interaction
      ['click', 'scroll', 'mousemove', 'mousewheel', 'touchstart'].forEach(function(e) {
        document.addEventListener(e, firstInteraction, {
          once: true
        });
      });

      function firstInteraction() {
        if (!userInteracted) {
          userInteracted = true;
          swiper.autoplay.start();
          swiperBannerTabs.autoplay.start();
        }
      }
    
      // On hover, stop the autoplay and freeze the slide
      $('.banner-swiper .banner-slider-content').hover(
        function () {
          swiper.autoplay.stop();           // Stop main Swiper
          swiperBannerTabs.autoplay.stop(); // Stop thumbnail Swiper
        },
        function () {
          swiper.autoplay.start();           // Restart main Swiper
          swiperBannerTabs.autoplay.start(); // Restart thumbnail Swiper
        }
      );
    }

    // Announcement section slider
    if ($(".announcement-swiper-content").length) {
      $(".announcement-swiper-content .swiper-slide").removeClass("invisible").removeClass("!hidden");
      $(".announcement-swiper-image .swiper-slide").removeClass("invisible").removeClass("!hidden");
      
      // Initialize the thumbnail Swiper
      const swiperAnnouncementImage = new Swiper(".announcement-swiper-image", {
        spaceBetween: 30,
        slidesPerView: 1,
        effect: "fade",
        speed: 1000,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            allowTouchMove: false,
          },
          995: {
            allowTouchMove: false,
          },
        },
      });
    
      // Initialize the main Swiper
      const swiperAnnouncement = new Swiper(".announcement-swiper-content", {
        slidesPerView: 1,
        effect: "fade",
        speed: 1000,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            allowTouchMove: true,
          },
          995: {
            allowTouchMove: false,
          },
        },
        pagination: {
          el: ".announcement-swiper-content .swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        thumbs: {
          swiper: swiperAnnouncementImage, // Connect the thumbnail Swiper
        },
        on: {
          slideChange: function () {
            // Get the speed of the swiper
            const speed = this.params.speed || 1000; // Default to 1000ms if speed is not defined
    
            // Get the previous slide
            const previousSlide = this.slides[this.previousIndex];
    
            // Find the heading elements inside the previous slide
            const previousHeadings = $(previousSlide).find(".text-up-stagger-animate");
    
            // Calculate total animation duration for the previous slide's lines
            let totalDuration = 0;
            previousHeadings.each(function (index, element) {
              const lines = new SplitType(element, {
                types: "lines",
                lineClass: "line",
              }).lines;
              totalDuration += lines.length * (speed / 1000) * 0.5; // Assuming each line takes 0.5 times the speed
            });
    
            // Get the current slide
            const activeSlide = this.slides[this.activeIndex];
    
            // Find the heading elements inside the current slide
            const headings = $(activeSlide).find(".text-up-stagger-animate");
    
            // Slide down animation for the text of the previous slide
            previousHeadings.each(function (index, element) {
              const lines = new SplitType(element, {
                types: "lines",
                lineClass: "line",
              }).lines;
    
              lines.forEach(function (line, lineIndex) {
                const words = new SplitType(line, {
                  types: "lines",
                  lineClass: "line",
                }).lines;
    
                words.forEach(function (word, wordIndex) {
                  gsap.to(word, {
                    y: "100%", // Slide down to hide inside the parent div
                    duration: (speed / 1000) * 0.5, // Duration proportional to speed
                    ease: "power2.out", // Use smoother easing
                  });
                });
              });
            });
    
            // Slide up animation for the text of the current slide
            headings.each(function (index, element) {
              const lines = new SplitType(element, {
                types: "lines",
                lineClass: "line",
              }).lines;
    
              lines.forEach(function (line, lineIndex) {
                const words = new SplitType(line, {
                  types: "lines",
                  lineClass: "line",
                }).lines;
    
                words.forEach(function (word, wordIndex) {
                  const delay =
                    totalDuration + lineIndex * (speed / 1000) * 0.1; // Delay each line animation
                  gsap.fromTo(
                    word,
                    { y: "100%" }, // Start from the bottom
                    {
                      y: 0, // Slide up to its original position
                      duration: (speed / 1000) * 0.5, // Duration proportional to speed
                      delay: delay,
                      ease: "power2.out", // Use smoother easing
                    }
                  );
                });
              });
            });
    
            const previousSlideIndex = this.slides[this.previousIndex],
              activeSlideIndex = this.slides[this.activeIndex];
            fadeInSliderDescription(speed + 200, ".description-container", previousSlideIndex, activeSlideIndex); //animate description
            fadeInSliderDescription(speed + 200, ".btn-container", previousSlideIndex, activeSlideIndex); //animate btn
          },
        },
      });

      // Disable autoplay initially
      swiperAnnouncement.autoplay.stop();
      swiperAnnouncementImage.autoplay.stop();
      let userInteracted = false;

      // Add event listener to start autoplay on user interaction
      ['click', 'scroll', 'mousemove', 'mousewheel', 'touchstart'].forEach(function(e) {
        document.addEventListener(e, firstInteraction, {
          once: true
        });
      });

      function firstInteraction() {
        if (!userInteracted) {
          userInteracted = true;
          swiperAnnouncement.autoplay.start();
          swiperAnnouncementImage.autoplay.start();
        }
      }
    
      // On hover, stop the autoplay and freeze the slide
      $('.announcement-swiper-content .swiper-slide').hover(
        function () {
          swiperAnnouncement.autoplay.stop();           // Stop main Swiper
          swiperAnnouncementImage.autoplay.stop(); // Stop thumbnail Swiper
        },
        function () {
          swiperAnnouncement.autoplay.start();           // Restart main Swiper
          swiperAnnouncementImage.autoplay.start(); // Restart thumbnail Swiper
        }
      );
    }
    
    if ($(".reputation-built-slider").length > 0) {
      let slidesView =
        parseInt($(".reputation-built-container").attr("data-slide-per-view")) +
        0.5;
      const swiper = new Swiper(".reputation-built-slider", {
        loop: false,
        speed: 1000,
        freeMode: false,
        slidesPerView: 1,
        grabCursor: true,
        allowTouchMove: true,
        spaceBetween: 22,
        draggable: true,

        breakpoints: {
          // when window width is > 1500px
          1500: {
            slidesPerView: slidesView,
          },
          1441: {
            slidesPerView: slidesView - 0.5,
          },
          996: {
            slidesPerView: slidesView > 3 ? slidesView - 1 : 2,
          },
          641: {
            slidesPerView: slidesView > 3 ? slidesView - 2 : 1.5,
          },
          0: {
            loop: false,
            slidesPerView: 1,
          },
        },

        navigation: {
          nextEl: ".reputation-built-container .swiper-button-next",
          prevEl: ".reputation-built-container .swiper-button-prev",
        },

        scrollbar: {
          el: ".reputation-built-container .swiper-scrollbar",
          draggable: true,
          dragSize: "60",
        },

        pagination: {
          el: ".reputation-built-container .swiper-pagination",
          type: "fraction",
          formatFractionTotal: function (num) {
            $(".reputation-built-container .total").text(addZeroToInitial(num));
          },
          formatFractionCurrent: function (num) {
            $(".reputation-built-container .current").text(addZeroToInitial(1));
          },
        },
      });

      swiper.isLocked
        ? $(".reputation-built-container .slider-navigation").hide()
        : $(".reputation-built-container .slider-navigation").show();

      $(window).on("resize", function () {
        swiper.isLocked
          ? $(".reputation-built-container .slider-navigation").hide()
          : $(".reputation-built-container .slider-navigation").show();
      });
    }

    // testimonial slider
    function testimonialSwiper(ele) {
      if ($(ele).length > 0) {
        // Remove `invisible` class and ensure all slides are visible
        $(ele).find(".swiper-slide").removeClass("invisible");

        // Destroy existing Swiper instance if it exists
        const existingSwiper = $(ele).data("swiper");
        if (existingSwiper) {
          existingSwiper.destroy(true, true);
        }

        // Initialize new Swiper
        const swiper = new Swiper(ele, {
          spaceBetween: 30,
          effect: "fade",
          allowTouchMove: true,
          fadeEffect: {
            crossFade: true,
          },
          navigation: {
            nextEl: `${ele} .swiper-button-next`,
            prevEl: `${ele} .swiper-button-prev`,
          },
          scrollbar: {
            el: `${ele} .swiper-scrollbar`,
            draggable: true,
            dragSize: "60",
          },
          pagination: {
            el: `${ele} .swiper-pagination`,
            type: "fraction",
            formatFractionTotal: function(num) {
              $(`${ele} .total`).text(addZeroToInitial(num));
            },
            formatFractionCurrent: function(num) {
              $(`${ele} .current`).text(addZeroToInitial(1));
            },
          },
          on: {
            init: function() {
              updateScrollBarVisibility(this);
            },
            transitionStart: function() {
              updateScrollBarVisibility(this);
            }
          }
        });

        // Store the swiper instance
        $(ele).data("swiper", swiper);
      }
    }
    
    // Function to update the visibility of the scrollbar
    function updateScrollBarVisibility(swiper) {
      const swiperContainer = $(swiper.el); // Get the Swiper container
      if (swiper.isLocked) {
        swiperContainer.find(".thin-scroll-bar").hide();
      } else {
        swiperContainer.find(".thin-scroll-bar").show();
      }
    }
    
    // Tab Switching Logic
    $('.tab-btn').on('click', function() {
      const tabId = $(this).data('tab-name'); // Assuming each tab has a data attribute for the corresponding slider
  
      testimonialSwiper(`.pioneer-testimonial-slider[data-tab-child="${tabId}"]`); // Initialize or re-initialize the swiper for that tab
    });
    
    // Initialize the first slider (assuming the first tab is active by default)
    testimonialSwiper('.pioneer-testimonial-slider-1');

    testimonialSwiper(".tuition-swiper");

    const swiperTestimonialTab = new Swiper(".testimonial-tab .swiper-container", {
      slidesPerView: 'auto',
      spaceBetween: 15,
      freeMode: false,
      navigation: {
        nextEl: ".testimonial-swiper-prev-btn",
        prevEl: ".testimonial-swiper-next-btn",
      },
      breakpoints: {
        0: {
          spaceBetween: 0,
          slidesPerView: 1,
        },
        768: {
          spaceBetween: 30,
          slidesPerView: 3,
        }
      },
    });

    const swiperUniversity = new Swiper(".university-tab-container", {
      freeMode: false,
      navigation: {
        nextEl: ".next-tab-slide",
        prevEl: ".prev-tab-slide",
      },
      breakpoints: {
        0: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 5,
        },
        995: {
          slidesPerView: 6,
        },
      },
    });

    // Find slides with 'text-pa-red' class
    const activePage = $('.university-tab-container .text-pa-red');
    
    // If we have red slides, activate the first one
    if (activePage.length) {
      const activeSlideIndex = activePage.parent().index(); // Activate the first slide with the class 'text-pa-red'
      swiperUniversity.slideTo(activeSlideIndex, 300, false); // Slide to the active index
      swiperUniversity.update(); // This will invoke the Swiper's slide effect and update the view
    }

    
    //video-testimonial block swiper
    const swiperVideoTestimonial = new Swiper(".video-testimonial-tab .swiper-container", {
      slidesPerView: 'auto',
      spaceBetween: 15,
      freeMode: false,
      navigation: {
        nextEl: ".next-tab-slide",
        prevEl: ".prev-tab-slide",
      },
      breakpoints: {
        0: {
          spaceBetween: 0,
          slidesPerView: 1,
        },
        768: {
          spaceBetween: 30,
          slidesPerView: 3,
        }
      },
    });

    const swiperCurricularTab = new Swiper(".curricular-tab .swiper-container", {
      freeMode: true,
      navigation: {
        nextEl: ".curricular-swiper-prev-btn",
        prevEl: ".curricular-swiper-next-btn",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          centeredSlides: true,
        },
        375: {
          slidesPerView: 2,
          centeredSlides: false,
        },
      },
    });

    // slider for news and events child menu
    const swiperChildTabMenu = new Swiper(".child-tab-menu-container", {
      freeMode: true,
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 50,
      navigation: {
        nextEl: ".next-tab-slide",
        prevEl: ".prev-tab-slide",
      },
    });

    function tabsSlider(containerName) {
      const swiperUniversity = new Swiper(containerName, {
        freeMode: false,
        navigation: {
          nextEl: ".next-tab-slide",
          prevEl: ".prev-tab-slide",
        },
        breakpoints: {
          0: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 5,
          },
          995: {
            slidesPerView: 6,
          },
        },
      });
    }

    tabsSlider(".scholar-tab-container");

    if ($(".important-date-swiper").length > 0) {
      const swiper = new Swiper(".important-date-swiper", {
        loop: false,
        speed: 1000,
        freeMode: false,
        slidesPerView: 1,
        grabCursor: true,
        allowTouchMove: true,
        spaceBetween: 40,
        draggable: true,

        breakpoints: {
          // when window width is > 1500px
          996: {
            slidesPerView: 2,
          },
          641: {
            slidesPerView: 1.5,
          },
          0: {
            loop: false,
            slidesPerView: 1,
            scrollbar: {
              dragSize: "30",
            },
          },
        },

        navigation: {
          nextEl: ".important-date-container .swiper-button-next",
          prevEl: ".important-date-container .swiper-button-prev",
        },

        scrollbar: {
          el: ".important-date-container .swiper-scrollbar",
          draggable: true,
          dragSize: "60",
        },

        pagination: {
          el: ".important-date-container .swiper-pagination",
          type: "fraction",
          formatFractionTotal: function (num) {
            $(".important-date-container .total").text(addZeroToInitial(num));
          },
          formatFractionCurrent: function (num) {
            $(".important-date-container .current").text(
              addZeroToInitial(num)
            );
          },
        },
      });

      swiper.isLocked
        ? $(".important-date-container .slider-navigation").hide()
        : $(".important-date-container .slider-navigation").show();

      $(window).on("resize", function () {
        swiper.isLocked
          ? $(".important-date-container .slider-navigation").hide()
          : $(".important-date-container .slider-navigation").show();
      });
    }

    //video list block swiper
    if ($(".video-list-block-swiper").length > 0) {
      const swiper = new Swiper(".video-list-block-swiper", {
        loop: false,
        speed: 1000,
        freeMode: false,
        grabCursor: true,
        allowTouchMove: true,
        spaceBetween: 20,
        draggable: true,

        breakpoints: {
          // when window width is > 1500px
          1024: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          0: {
            loop: false,
            slidesPerView: 1,
            scrollbar: {
              dragSize: "30",
            },
          },
        },

        navigation: {
          nextEl: ".video-list-block-container .swiper-button-next",
          prevEl: ".video-list-block-container .swiper-button-prev",
        },
      });

      swiper.isLocked
        ? $(".video-list-block-container .slider-navigation").hide()
        : $(".video-list-block-container .slider-navigation").show();

      $(window).on("resize", function () {
        swiper.isLocked
          ? $(".video-list-block-container .slider-navigation").hide()
          : $(".video-list-block-container .slider-navigation").show();
      });
    }

    // Pioneer in the news slider thumb
    if ($('.news-image-container').length) {
      const swiperNewsImage = new Swiper(".news-image-container", {
        slidesPerView: "auto",
        freeMode: false,
        watchSlidesProgress: true,
        loop: false,
        slideToClickedSlide: true,
        breakpoints: {
          996: {
              centeredSlides: false,
          },
          0: {
              centeredSlides: true,
          },
        },
      });

      const swiperNewsContentOptions = {
        spaceBetween: 10,
        effect: "fade",
        speed: 1000,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      };

      // Conditional thumbs assignment
      if (window.innerWidth > 995) {
        swiperNewsContentOptions.thumbs = {
          swiper: swiperNewsImage,
        };
      }

      const swiperNewsContent = new Swiper(".news-content-container", swiperNewsContentOptions);

      // Conditional controller assignment
      if (window.innerWidth <= 995) {
        swiperNewsImage.controller.control = swiperNewsContent;
        swiperNewsContent.controller.control = swiperNewsImage;
      }

      // On hover, stop the autoplay and freeze the slide
      $('.news-content-container .swiper-slide').hover(
        function () {
          swiperNewsContent.autoplay.stop();           // Stop main Swiper
        },
        function () {
          swiperNewsContent.autoplay.start();           // Restart main Swiper
        }
      );
    }
  });

  //Window On Ready function
  $(window).on("load resize", function () {
    // Sticly slider mobile view code starts
    if ($(".sticky-slider-container-wrapper").length) {
      window.innerWidth >= 1024 ? $(".sticky-slider-container-wrapper").removeClass("overflow-hidden") : $(".sticky-slider-container-wrapper").addClass("overflow-hidden");
    }
    if ($(".sticky-slider-container-wrapper .content-swiper").length > 0 && window.innerWidth <= 1024 && !$(".sticky-slider-container-wrapper .number-swiper").hasClass("swiper-initialized")) {
      const numberSwiper = new Swiper(
        ".sticky-slider-container-wrapper .number-swiper",
        {
          freeMode: false,
          centeredSlides: false,
          followFinger: false,
          grabCursor: true,
          spaceBetween: "40",
          slidesPerView: 1,
        }
      );
      
      $(".sticky-slider-container-wrapper .content-swiper .swiper-slide").removeClass("invisible");
      $(".sticky-slider-container-wrapper .sticky-mobile-swiper").removeClass("overflow-hidden");

      const contentSwiper = new Swiper(".sticky-slider-container-wrapper .content-swiper", {
        spaceBetween: 8,
        slidesPerView: 1,
        freeMode: false,
        centeredSlides: false,
        followFinger: false,
        grabCursor: true,

        scrollbar: {
          el: ".sticky-mobile-swiper .swiper-scrollbar",
          draggable: true,
          dragSize: "60",
        },

        pagination: {
          el: ".sticky-mobile-swiper .swiper-pagination",
          type: "fraction",
          formatFractionTotal: function (num) {
            $(".sticky-mobile-swiper .total").text(addZeroToInitial(num));
          },
          formatFractionCurrent: function (num) {
            $(".sticky-mobile-swiper .current").text(addZeroToInitial(1));
          },
        },
      });
      numberSwiper.controller.control = contentSwiper;
      contentSwiper.controller.control = numberSwiper;
    }
    // Sticly slider mobile view code ends

    //start of apply steps slider 
    if ($('.steps-swiper').length && $(".apply-steps-slider").length) {
      var stepsSwiper = new Swiper(".steps-swiper", { 
        watchSlidesProgress: true,
        initialSlide: howToApplySlide,
        
        on: {
          slideChange: function () {
            howToApplySlide = this.realIndex;
            swiperContent.slideTo(howToApplySlide); // Sync the second slider
          },
        },
        
        breakpoints: {
          0: {
            spaceBetween: 90,
            slidesPerView: 3,
            allowTouchMove: true,
            centeredSlides: true,
            touchEventsTarget: 'container',
          },
          480: {
            spaceBetween: 0,
            slidesPerView: 3,
            allowTouchMove: true,
            centeredSlides: true,
            touchEventsTarget: 'container',
          },
          998: {
            slidesPerView: 5,
            allowTouchMove: false,
            centeredSlides: true,
          },
          1024: {
            slidesPerView: 5,
            centeredSlides: false,
            allowTouchMove: false,
          }
        },
      });
  
      var swiperContent = new Swiper(".apply-steps-slider", {
        spaceBetween: 22,
        effect: "fade",
        speed: 1000,
        initialSlide: howToApplySlide,

        fadeEffect: {
          crossFade: true, // added(resolve the overlapping of the slides)
        },

        navigation: {
          nextEl: ".apply-steps-container .swiper-button-next",
          prevEl: ".apply-steps-container .swiper-button-prev",
        },

        thumbs: {
          swiper: stepsSwiper,
        },

        scrollbar: {
          el: ".apply-steps-container .swiper-scrollbar",
          draggable: true,
          dragSize: "60",
        },

        breakpoints: {
          0: {
            allowTouchMove: true,
          },
          680: {
            allowTouchMove: false,
          }
        },

        pagination: {
          el: ".apply-steps-container .swiper-pagination",
          type: "fraction",
          formatFractionTotal: function (num) {
            let applyStepsSlides = $(".apply-steps-container .swiper-wrapper").children().length;
            $(".apply-steps-container .total").text(addZeroToInitial(applyStepsSlides));
          },
          formatFractionCurrent: function (num) {
            $(".apply-steps-container .current").text(addZeroToInitial(1));
          },
        },

        on: {
          slideChange: function () {
            howToApplySlide = this.realIndex;
            stepsSwiper.slideTo(howToApplySlide); // Sync the first slider
            $(".slider-navigation li").removeClass("active-step");
            $(".slider-navigation li:eq(" + howToApplySlide + ")").addClass("active-step");
          },
        }
      });
    }
    //end of apply steps slider

    //slider for pioneer updates at 1024px
    if (
      $(".updates-section-container .updates-swiper").length > 0 &&
      $(window).width() <= 1024 &&
      !$(".updates-section-container .number-swiper").hasClass(
        "swiper-initialized"
      )
    ) {
      const numberSwiper = new Swiper(
        ".updates-section-container .number-swiper",
        {
          freeMode: false,
          spaceBetween: 8,
          followFinger: false,
          grabCursor: true,
          slidesPerView: 1,
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            640: {
              slidesPerView: 1.5,
            },
          },

          scrollbar: {
            el: ".updates-section-container .number-swiper-container .swiper-scrollbar",
            draggable: true,
            dragSize: "60",
          },

          pagination: {
            el: '.updates-section-container .number-swiper-container .swiper-pagination',
            type: "fraction",
            formatFractionTotal: function (num) {
              $('.updates-section-container .number-swiper-container .total').text(addZeroToInitial(num));
            },
            formatFractionCurrent: function (num) {
              $('.updates-section-container .number-swiper-container .current').text(addZeroToInitial(1));
            },
          },
        }
      );
      $(".updates-section-container .updates-swiper .swiper-slide").removeClass(
        "invisible"
      );

      const contentSwiper = new Swiper(
        ".updates-section-container .updates-swiper",
        {
          spaceBetween: 8,
          slidesPerView: 1,
          freeMode: false,
          followFinger: false,
          grabCursor: true,
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            640: {
              slidesPerView: 1.5,
            },
          },
        }
      );
      numberSwiper.controller.control = contentSwiper;
      contentSwiper.controller.control = numberSwiper;

      numberSwiper.isLocked
        ? $(".updates-section-container .updates-silder-button").hide()
        : $(".updates-section-container .updates-silder-button").show();

      $(window).on("resize", function () {
        numberSwiper.isLocked
          ? $(".updates-section-container .updates-silder-button").hide()
          : $(".updates-section-container .updates-silder-button").show();
      });
    }

    if ($(".build-future-slider").length > 0) {
      const gallerySwiper = new Swiper(".build-future-slider", {
        speed: 1000,
        allowTouchMove: true,
        spaceBetween: 22,

        breakpoints: {
          1180: {
            slidesPerView: 3,
          },
          // when window width is >= 1025px
          1025: {
            slidesPerView: 2.5,
          },
          // when window width is >= 996px
          996: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          700: {
            slidesPerView: 2,
            spaceBetween: 22,
          },
          550: {
            slidesPerView: 1.5,
            spaceBetween: 15,
          },
          0: {
            slidesPerView: 1,
            scrollbar: {
              dragSize: "30",
            },
          },
        },

        navigation: {
          nextEl: ".build-future-container .swiper-button-next",
          prevEl: ".build-future-container .swiper-button-prev",
        },

        scrollbar: {
          el: ".build-future-container .swiper-scrollbar",
          draggable: true,
          dragSize: "60",
        },

        pagination: {
          el: '.build-future-container .swiper-pagination',
          type: "fraction",
          formatFractionTotal: function (num) {
            $('.build-future-container .total').text(addZeroToInitial(num));
          },
          formatFractionCurrent: function (num) {
            $('.build-future-container .current').text(addZeroToInitial(1));
          },
        },
      });

      gallerySwiper.isLocked
        ? $(".build-future-container .slider-btn-container").hide()
        : $(".build-future-container .slider-btn-container").show();

      $(window).on("resize", function () {
        gallerySwiper.isLocked
          ? $(".build-future-container .slider-btn-container").hide()
          : $(".build-future-container .slider-btn-container").show();
      });
    }

    //this function will hide button if slides are less than slidesperview
    function hideSliderBtn(swiperStatistics, uniqueParentClass) {
      for (const data in swiperStatistics) {
        if (data === 'isLocked') {
          const currentElement = swiperStatistics.el,
            isLocked = swiperStatistics.isLocked,
            $currentElement = $(currentElement)?.closest(`.${uniqueParentClass}`)?.find('.navigator-btn');
          isLocked ? $currentElement?.hide() : $currentElement?.show();
        }
      }
    }

    $('.statistics-slider').each(function (index, element) {
      const uniqueClass = `statistics-slider-${index}`,
        uniqueParentClass = `statistics-container-${index}`;
      $(element).addClass(uniqueClass)?.closest('.statistics-container').addClass(uniqueParentClass);
      let slidesNumView =
        parseInt($(element).closest('.statistics-container').attr("data-slide-per-view"));
      const swiperStatistics = new Swiper(`.${uniqueClass}`, {
        loop: false,
        speed: 1000,
        freeMode: false,
        slidesPerView: 1,
        allowTouchMove: true,
        spaceBetween: 28,

        breakpoints: {
          1024: {
            slidesPerView: slidesNumView,
          },
          996: {
            slidesPerView: 3,
          },
          641: {
            slidesPerView: 2,
          },
          0: {
            slidesPerView: 1,
            scrollbar: {
              dragSize: "30",
            },
          },
        },

        navigation: {
          nextEl: `.${uniqueParentClass} .swiper-button-next`,
          prevEl: `.${uniqueParentClass} .swiper-button-prev`,
        },

        scrollbar: {
          el: `.${uniqueParentClass} .swiper-scrollbar`,
          draggable: true,
          dragSize: "60",
        },

        pagination: {
          el: `.${uniqueParentClass} .swiper-pagination`,
          type: "fraction",
          formatFractionTotal: function (num) {
            let statisticsSlides = $(`.${uniqueParentClass} .swiper-wrapper`).children().length;
            $(`.${uniqueParentClass} .total`).text(addZeroToInitial(statisticsSlides));
          },
          formatFractionCurrent: function (num) {
            $(`.${uniqueParentClass} .current`).text(addZeroToInitial(1));
          },
        },
      });

      //this function will hide button if slides are less than slidesperview
      hideSliderBtn(swiperStatistics, uniqueParentClass);

      $(window).on("resize", hideSliderBtn(swiperStatistics, uniqueParentClass));
    });

    function tabsSlider(containerName) {
      const swiperUniversity = new Swiper(containerName, {
        freeMode: false,
        spaceBetween: 60,
        navigation: {
          nextEl: ".next-tab-slide",
          prevEl: ".prev-tab-slide",
        },
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            spaceBetween: 50,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 55,
          },
          995: {
            slidesPerView: 6,
            slidesOffsetBefore: 25,
          },
        },
      });
    }

    tabsSlider(".scholar-tab-container");

    function calculateWidth() {
      let slideWidth;
      if ($(window).width() > 767) {
        slideWidth = $(".history-img-slider li").width();
        return slideWidth;
      } else {
        slideWidth = 200;
        return slideWidth;
      }
    }

    //history block slider
    if ($(".history-tab-slider").length) {
      const swiperHistoryTab = new Swiper(".history-tab-slider", {
        slidesPerView: 9,
        freeMode: false,
        breakpoints: {
          0: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 8,
          },
          995: {
            slidesPerView: 10,
          },
        },

      });

      const swiperHistoryProgressBar = new Swiper(".history-progress-bar", {
        slidesPerView: 9,
        freeMode: false,
        breakpoints: {
          0: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 8,
          },
          995: {
            slidesPerView: 10,
          },
        },

      });

      const swiperHistoryImg = new Swiper(".history-img-slider", {
        slidesPerView: "auto",
        slidesOffsetAfter: calculateWidth() - 200,
        watchSlidesProgress: true,

      });

      const swiperHistoryDetail = new Swiper(".history-detail-slider", {
        updateOnWindowResize: false,
        freeMode: false,
        effect: "fade",
        speed: 1000,
        slidesPerView: 1,
        allowTouchMove: false,
        touchStartPreventDefault: false, // Allow text selection
        initialSlide: historyDetailSlider, //added to resolve resizing issue
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          996: {
            allowTouchMove: false,
          },
          0: {
            allowTouchMove: true,
          },
        },
        thumbs: {
          swiper: swiperHistoryTab
        },
        on: {
          slideChange: function () {
            historyDetailSlider = this.realIndex;
            let spanWidth = $(".year-history-slider").find(".swiper-slide-thumb-active").attr("data-offset");
            $(".history-progress-bar .slider-line").css("width", spanWidth);
          }
        },
      });
      swiperHistoryDetail.controller.control = swiperHistoryImg;
      swiperHistoryImg.controller.control = swiperHistoryDetail;
      swiperHistoryTab.controller.control = swiperHistoryProgressBar;

      //to add data-offset for history slider
      $('.history-tab-slider.swiper-initialized li').each(function () {
        let listElement = $(this);
        offset = listElement.position().left + listElement.width();
        listElement.attr('data-offset', offset);
      });
    }

    // For statistics block
    $('.statistics-image-slider').each(function (index, element) {
      const uniqueClass = `statistics-image-slider-${index}`,
        uniqueParentClass = `statistics-image-container-${index}`;
      $(element).addClass(uniqueClass)?.closest('.statistics-image-container').addClass(uniqueParentClass);

      let slidesView = $(`.${uniqueClass}`).find('.swiper-slide').length;

      const swiperStatistics = new Swiper(`.${uniqueClass}`, {
        loop: false,
        speed: 1000,
        freeMode: false,
        allowTouchMove: true,
        spaceBetween: 28,

        breakpoints: {
          0: {
            slidesPerView: (slidesView > 1) ? 1.1 : 1,
            spaceBetween: 8,
            allowTouchMove: true,
          },
          1024: {
            slidesPerView: 1,
            allowTouchMove: false,
          },
        },

        navigation: {
          nextEl: `.${uniqueParentClass} .swiper-button-next`,
          prevEl: `.${uniqueParentClass} .swiper-button-prev`,
        },

        scrollbar: {
          el: `.${uniqueParentClass} .swiper-scrollbar`,
          draggable: true,
          dragSize: "60",
        },

        pagination: {
          el: `.${uniqueParentClass} .swiper-pagination`,
          type: "fraction",
          formatFractionTotal: function (num) {
            $(`.${uniqueParentClass} .total`).text(addZeroToInitial(num));
          },
          formatFractionCurrent: function (num) {
            $(`.${uniqueParentClass} .current`).text(addZeroToInitial(1));
          },
        },
      });

      //this function will hide button if slides are less than slidesperview
      hideSliderBtn(swiperStatistics, uniqueParentClass);

      $(window).on("resize", hideSliderBtn(swiperStatistics, uniqueParentClass));
    });

    // For Research Journal Slider block
    $('.research-journal-slider').each(function (index, element) {
      const uniqueClass = `research-journal-slider-${index}`,
        uniqueParentClass = `research-journal-slider-container-${index}`;
      $(element).addClass(uniqueClass)?.closest('.research-journal-slider-container').addClass(uniqueParentClass);

      const swiperJournal = new Swiper(`.${uniqueClass}`, {
        loop: false,
        speed: 1000,
        freeMode: false,
        slidesPerView: 1,
        allowTouchMove: true,
        spaceBetween: 20,

        breakpoints: {
          1024: {
            slidesPerView: 3.2,
          },
          996: {
            slidesPerView: 3,
          },
          641: {
            slidesPerView: 2,
          },
          0: {
            slidesPerView: 1,
            scrollbar: {
              dragSize: "30",
            },
          },
        },

        navigation: {
          nextEl: `.${uniqueParentClass} .swiper-button-next`,
          prevEl: `.${uniqueParentClass} .swiper-button-prev`,
        },
      });

      //this function will hide button if slides are less than slidesperview
      hideSliderBtn(swiperJournal, uniqueParentClass);

      $(window).on("resize", hideSliderBtn(swiperJournal, uniqueParentClass));
    });
  });

  //Window On Scroll function
  $(window).on("load scroll", function () {
    // Sticky slider code starts
    if ($(".sticky-slider").length > 0 && window.innerWidth > 1023) {
      const $this = $(".sticky-slider .sticky-content"),
        article = $(".sticky-slider .sticky-content article"), // Fetch all card articles
        offset = $this.offset(), // get top and left values of ".sticky-slider"
        height = $this.height(), // get height of ".sticky-slider"
        centerY = offset.top + height / 2,
        numberList = $(".sticky-slider .number-list");

      $(numberList).each((index, ele) => {
        const number = $(ele).offset();

        if (
          (number.top - centerY > 0 && number.top - centerY < 50) ||
          (number.top - centerY < 0 && number.top - centerY > -80)
        ) {
          $(numberList).removeClass("opacity-30");
          $(numberList).css("opacity", 0.3);
          $(ele).css("opacity", 1);
          $(article).addClass("hidden");
          $(article[index]).removeClass("hidden");
        }
      });
    }
    // Sticky slider code ends

    // Header Navigation Starts
    const scroll = $(window).scrollTop();
    const headerTop = $(".header-top");
    const header = $("header");

    if ($(window).width() > 1025) {
      if (scroll > 200) {
        $(header).addClass("scroll-active");
        $(headerTop).slideUp(300);
      } else {
        $(header).removeClass("scroll-active");
        $(headerTop).slideDown(300);
      }
    }

    if (scroll > 250) {
      $(header).addClass("scroll-active");
    } else {
      $(header).removeClass("scroll-active");
    }
    // Header Navigation Ends

    // pioneer updates sticky slider starts
    if ($(".pioneer-sticky-slider").length > 0 && window.innerWidth > 1023) {
      const $this = $(".pioneer-sticky-slider .sticky-contents"),
        article = $(
          ".pioneer-sticky-slider .sticky-contents .sticky-contents-img"
        ),
        offset = $this.offset(),
        height = $this.height(),
        centerY = offset.top + height / 2 - 100,
        numberList = $(".pioneer-sticky-slider .number-list");

      $(numberList).each((index, ele) => {
        const number = $(ele).offset();

        if (
          (number.top - centerY > 0 && number.top - centerY < 50) ||
          (number.top - centerY < 0 && number.top - centerY > -80)
        ) {
          $(numberList).removeClass("opacity-30");
          $(numberList).css("opacity", 0.3);
          $(ele).css("opacity", 1);
          $(article).addClass("hidden");
          $(article[index]).removeClass("hidden");
        }
      });
    }
    // pioneer updates sticky slider ends

    if ($(".pioneer-updates-sticky-slider").length && window.innerWidth > 1023) {
      const $this = $(".pioneer-updates-sticky-slider .sticky-contents"),
        articleCta = $('.update-sticky-slider-btn'),
        offset = $this.offset(),
        height = articleCta.length ? $this.height() + 50 : $this.height(),
        centerY = offset.top,
        numberList = $(".pioneer-updates-sticky-slider .number-list"),
        contentActive = (height / numberList.length) - (articleCta.length ? 0 : 50);
      let initialActiveState = 1,
        headerHeight = $('header').outerHeight(true),
        childMenuHeight = $('.child-page-menu').length ? $('.child-page-menu').outerHeight(true) : 15,
        wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0;

      $this.css('top', headerHeight + childMenuHeight + wpAdminBar);

      $(numberList).each((index, ele) => {
        let activeArticleElement = $(ele);
        const number = activeArticleElement.offset(),
          updatedActiveState = contentActive * initialActiveState;

        if (
          (number.top - centerY > 0 && number.top - centerY < updatedActiveState) ||
          (number.top - centerY < 0 && number.top - centerY > -updatedActiveState)
        ) {
          $(numberList).removeClass("opacity-30").removeClass("active-article");
          $(numberList).css("opacity", 0.3);
          activeArticleElement.css("opacity", 1).addClass("active-article");
        }
        initialActiveState += 0.5;
      });
    }
  });

  $(window).on("load resize", function () {
    //to adjust the div with years in history slider
    if ($('.history-tab-slider')) {
      let liContainerWidth = $('.history-tab-slider li:first-child').width(),
        widthCalculation = liContainerWidth / 1.26;
      $('.history-progress-bar').css("transform", `translateX(${-widthCalculation}px)`)
    }
  });
})(jQuery, window, document);
